'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _InputAdornment = _interopRequireDefault(require("@mui/material/InputAdornment"));
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
var _utilities = require("Shared/utilities");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let app = window.app;
class TextInput extends _react.PureComponent {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      id: String(++app.form_index)
    });
    (0, _defineProperty2.default)(this, "handleChange", e => {
      const component = this,
        props = this.props,
        state = this.state;
      if (typeof props.onChange !== 'function') return;
      let value = e.target.value;
      if (props['auto-caps'] === true) {
        value = value.toUpperCase();
      }
      let returned_value = value;
      if (props['safe-value']) {
        returned_value = (0, _utilities.cleanNumber)({
          number: value,
          positive: props['allow-negative'] !== true,
          int: props.int === true,
          digits: props.digits,
          max: props.max
        });
      }
      props.onChange({
        e: e,
        value: returned_value,
        name: props.name,
        error_name: component.getStatusName()
      });
    });
    (0, _defineProperty2.default)(this, "getStatusName", () => {
      var _props$name;
      const component = this,
        props = this.props,
        state = this.state;
      return !props['error-prefix'] ? props.name : ((_props$name = props.name) === null || _props$name === void 0 ? void 0 : _props$name.includes('[')) === true ? props['error-prefix'] + '[' + props.name.replace('[', '][') : props['error-prefix'] + '[' + props.name + ']';
    });
  }
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (typeof props.onChange !== 'function') return;
    if (typeof props.value !== 'undefined') return;
    let value = props['default-value'] || '';
    if (props['auto-caps'] === true) {
      value = value.toUpperCase();
    }
    let returned_value = value;
    if (props['safe-value']) {
      returned_value = (0, _utilities.cleanNumber)({
        number: value,
        positive: props['allow-negative'] !== true,
        int: props.int === true,
        digits: props.digits,
        max: props.max
      });
    }
    props.onChange({
      e: null,
      value: returned_value,
      name: props.name,
      error_name: component.getStatusName(),
      source: 'DidMount'
    });
  }
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status_name = component.getStatusName();
    let status = props.status[status_name];
    const error_msg = (status === null || status === void 0 ? void 0 : status.error) || undefined;
    const prefix = props.prefix ? /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
      position: "start"
    }, props.prefix) : undefined;
    const suffix = props.suffix ? /*#__PURE__*/_react.default.createElement(_InputAdornment.default, {
      position: "end"
    }, props.suffix) : undefined;
    let class_list = props.className || (props.full_width ? 'u-full-width' : '');
    class_list = class_list.split(' ');
    class_list.push('u-overflow-hidden');
    if (!props.label) {
      class_list.push('textinput-without-label');
    }
    var output = /*#__PURE__*/_react.default.createElement("div", {
      className: class_list.join(' ')
    }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
      error: error_msg ? true : false,
      fullWidth: props.full_width,
      id: state.id,
      label: props.label,
      helperText: error_msg,
      variant: props.variant,
      disabled: props['read-only'] === true,
      value: props.value || '',
      name: status_name,
      type: props.type,
      required: props.required || false,
      multiline: props.multiline,
      rows: props.rows,
      autoComplete: props.autoComplete,
      onChange: component.handleChange,
      placeholder: props.placeholder,
      InputLabelProps: {
        className: 'mui-textinput-label mui-textinput-label--' + props.type
      },
      InputProps: {
        startAdornment: prefix,
        endAdornment: suffix,
        className: 'mui-textinput mui-textinput--' + props.type
      },
      sx: {
        display: 'flex',
        flexWrap: 'wrap',
        '& label.Mui-focused': {
          fontSize: 'inherit'
        }
      }
    }));
    return output;
  }
}
exports.default = TextInput;
TextInput.propTypes = {
  onChange: _propTypes.default.func,
  className: _propTypes.default.string,
  full_width: _propTypes.default.bool,
  label: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  value: _propTypes.default.string,
  type: _propTypes.default.string,
  input_format: _propTypes.default.object,
  multiline: _propTypes.default.bool,
  rows: _propTypes.default.string,
  'auto-caps': _propTypes.default.bool,
  status: _propTypes.default.object
};
TextInput.defaultProps = {
  full_width: true,
  type: 'text',
  multiline: false,
  rows: '1',
  variant: 'standard',
  'auto-caps': false,
  status: {}
};
